import { CircleExclamationIcon, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../Translations';

/**
 * Action component displayed for experiences where the user
 * does not have an active license. Shows "Preview Only" to indicate
 * they can view the content but cannot enroll.
 */
function UnlicensedAction() {
  return (
    <div className="flex items-center gap-x-2">
      <CircleExclamationIcon size="md" color="gray" />
      <Typography color="gray" variant="caption">
        <T kind="Preview Only" />
      </Typography>
    </div>
  );
}

export default observer(UnlicensedAction);
